export const environment = {
  production: true,
  urlApi: 'https://dev-platform.valesaudesempre.com.br/api',
  urlApiPet: 'https://dev-platform.valesaudepet.com.br/api',
  version: '1.23.0',
  releaseStage: 'stage',
  BUGSNAG_KEY: '019a98f198b87596427a449713e1fd43',
  SALT: ',s)S.X-p;SdwsA2&lR.dIy|SCg}bZ1{&7y^%kpk2u9V+{mEO%n3HccBYJIKhFujb',
};
